var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpeninNew = function SvgOpeninNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M14.13 3.75h6.861v6.862h-2V7.164l-7.086 7.086-1.414-1.414 7.086-7.086H14.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M3.75 4.922h8.034v2H5.75v12.07h12.069v-6.035h2v8.034H3.75z"
  })));
};
export default SvgOpeninNew;